import { create } from "zustand";
import { VisitorsConversionType } from "./widgets/OverallConversion/OverallConversion.types";

interface IDashboardStore {
  referringDomains: VisitorsConversionType[];
  // eslint-disable-next-line no-unused-vars
  setReferringDomains: (value: IDashboardStore["referringDomains"]) => void;
}

const initial_state = {
  referringDomains: [],
};

export const useDashboardStore = create<IDashboardStore>((set) => ({
  ...initial_state,
  setReferringDomains: (value) => set({ referringDomains: value }),

  reset: () => set(initial_state),
}));
